import fetchAPI from '../../../../lib/utils/fetch-api'
import {ISaveTypeRequest} from './types'

export const saveType = async (formData: ISaveTypeRequest) => {
  try {
    const response = await fetchAPI(
      `/api/enum/type`,
      { method: 'POST', body: JSON.stringify(formData) }
    )
    if (response['errors']) {
      let error = response['errors']
      if (Array.isArray(error)) {
        error = error.join()
      }
      throw new Error(error)
    }
    return response
  } catch (err) {
    console.error(err)
    return false
  }
}
